
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import Contact from "../shared/Contact";
import { Button } from "@ronuse/noseur";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import * as ReactRouterDom from "react-router-dom";
import { Debugger, CacheManager, Utils, Schemes } from "../../utils";
import { ApiResponseData, IPlatform, SanitizedResponse, SupportArticleService, ISupportArticle } from "../../services";

function SupportArticle() {
    const navigate = ReactRouterDom.useNavigate();
    const labels = i18nManager.Labels.support_article;
    const { platform, id } = ReactRouterDom.useParams();
    const activePlatform = CacheManager.getPlatform(platform);
    const supportArticleService = SupportArticleService.getInstance();
    const [supportArticle, setSupportArticle] = React.useState<ISupportArticle>({} as any);
    const [mostHelpfulSupportArticlesInCategory, setMostHelpfulSupportArticlesInCategory] = React.useState<ApiResponseData<ISupportArticle>>({});

    React.useEffect(() => {
        if (!activePlatform) return;
        supportArticleService.getSingleSupportArticle(id!).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("SupportArticle:useEffect:getSingleSupportArticle", sanitized);
            setSupportArticle(sanitized);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
            navigate(`/${platform}`);
        });
        supportArticleService.querySupportArticles({ sort: "helpful,DESC", "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("SupportArticle:useEffect:querySupportArticles", sanitized);
            setMostHelpfulSupportArticlesInCategory(sanitized);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="support">
        <Header title={supportArticle.title} />
        <Breadcrumb breadCrumbs={[
            { label: supportArticle.category?.name, location: `/${platform}/category/${supportArticle.category?.external_id}` },
            { label: supportArticle.title, location: `/${platform}/article/${supportArticle.external_id}` }
        ]} />
        <div className="support-article">
            <div className="container">
                <div className="content" dangerouslySetInnerHTML={{ __html: Utils.MARKDOWN_CONVERTER.makeHtml(supportArticle.content) }} />
                <div className="sibling-articles">
                    <span>{labels.articles_in_category}</span>
                    {mostHelpfulSupportArticlesInCategory.content?.map((supportArticle) => (<a key={supportArticle.external_id} href={`/article/${supportArticle.external_id}`}>
                        {supportArticle.title}
                    </a>))}
                </div>
            </div>
            <div className="helpful">
                <span className="title">{labels.was_article_helpful}</span>
                <div>
                    <div>
                        <Button scheme={Schemes.RIVTN_HERA} leftIcon="fa fa-thumbs-up" onClick={(e) => markArticleHelpful(e.target, true)} rounded outlined/>
                        <span>{supportArticle.helpful}</span>
                    </div>
                    <div>
                        <Button scheme={Schemes.RIVTN_HERA} leftIcon="fa fa-thumbs-down" onClick={(e) => markArticleHelpful(e.target, false)} rounded outlined/>
                        <span>{supportArticle.not_helpful}</span>
                    </div>
                </div>
            </div>
        </div>
        <Contact />
        <Footer />
    </div>);

    function markArticleHelpful(button: any, helpful: boolean) {
        button.style.opacity = "0.5";
        button.style.pointerEvents = "none";
        if (!supportArticle.external_id) return;
        supportArticleService.markArticleHelpful(supportArticle.external_id, helpful).then(({ sanitized }: SanitizedResponse<any>) => {
            Utils.reportSuccess(labels.thanks);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }

}

export default SupportArticle;
